import { render, staticRenderFns } from "./videoComment.vue?vue&type=template&id=124fec50&scoped=true&"
import script from "./videoComment.vue?vue&type=script&lang=js&"
export * from "./videoComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fec50",
  null
  
)

export default component.exports